export class AutomatGroup {
    constructor() {
    }

    _id?:string;
    name: string;
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/automatGroup.ts